import Asciidoc from './asciidoc/reducer'
import AccessToken from './asciidoc/Auth/reducer'

export default {
    Asciidoc,
    AccessToken
};
